var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isProd } from './trackingService';
const keys = {
    myfridays: {
        prod: '6Le4krkqAAAAAAwp6qLQwzfByjDV_D6dTSoP8LIM',
        dev: '6LeskrkqAAAAABHSpNyypM4EwFdog42S4-zZeryc'
    },
    mytennights: {
        prod: '6LcukrkqAAAAAGBQxQRAHo5GeRO9C4DncUJ8zYPg',
        dev: '6LeGzLMqAAAAACezKw7JApTru4IkSfwSMo2FgLHg'
    },
    charity: {
        prod: '6LfHlbkqAAAAAK0bCy0FSx7LHPNTTNO8ovlCuCdP',
        dev: '6Le6lbkqAAAAAFPx8_59ojtzaXAHVT4mp5kEIFtl'
    },
    mytendays: {
        prod: '6LfSlrkqAAAAAHNHbmPyPGKO6tSF_B9hU8d2PXPh',
        dev: '6LfIlrkqAAAAAPxklQLg2xvmYD0DbNOJ6eT-ihw-'
    },
    givematch: {
        prod: '6LcYA9UmAAAAAP9uc6FR55wV7NpQUXHCe548KboE',
        dev: '6Ld5Us8mAAAAAPuU0nNFAjPsQYIyfvJ78nIzX1RD'
    }
};
let isRecaptchaLoaded = false;
const attachRecaptchaToDom = (API_KEY) => {
    const script = document.createElement('script');
    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${API_KEY}`;
    document.body.appendChild(script);
    isRecaptchaLoaded = true;
};
export default class RecaptchaV3 {
    constructor(page, domain = 'givematch') {
        if (!keys[domain]) {
            throw new Error(`Invalid domain: ${domain}`);
        }
        this.API_KEY = keys[domain][isProd() ? 'prod' : 'dev'];
        if (!isRecaptchaLoaded) {
            attachRecaptchaToDom(this.API_KEY);
        }
        this.page = page;
    }
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let token = '';
                yield window.grecaptcha.execute(this.API_KEY, { action: this.page }).then((res) => { token = res; });
                return token;
            }
            catch (e) {
                console.error('Failed to get token', e);
                return '';
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,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